export default "__VITE_ASSET__Bl_vIMh2__"